<template>
  <div class="order_block comment-block">
    <h3 class="title">Комментарий к заказу</h3>
    <div class="content">
      <textarea placeholder="Ваши пожелания к заказу" :value="commentData" @input="comment_change($event)"></textarea>
    </div>
  </div>
</template>

<script>

export default {
  name: 'CommentBlock',
  props: {
    commentData: String
  },
  components: {

  },
  data() {
    return{

    }
  },
  mounted() {

  },
  methods : {
    comment_change : function(e) {
      this.$emit("comment_change", e.target.value);
    },
  }
}
</script>

<style scoped>

.comment-block {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.comment-block .content textarea {
  width: 100%;
  height: 120px;
  resize: none;
  padding: 15px 20px;
  box-sizing: border-box;
  outline: none;
  border-radius: 8px;
  border: 1px solid var(--Border, #EDEDED);
  background: var(--BG, #F8F8F8);

  color: var(--Black, #222);
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
}

/*MOBILE*/
@media (max-width: 1250px)
{

}
</style>



<style>

</style>
